// В.1.f-1: общий хелпер перемещения юнита между ячейками поля.
//
// Поведение:
//   - unit перемещается с (unit.line, unit.slot) на (destLine, destSlot)
//     ВНУТРИ той же стороны (owner unit'а).
//   - Сохраняются: HP, броня, Моды, баффы, Молчание, derivedKeywords —
//     всё, что приклеено к instance.
//   - После перемещения — пересчёт State Resolver: Цепь командования,
//     line-triggers (Снайпер на 2-й линии получает Пробитие, Мех — Провокацию,
//     Расчёт — Неистовство и т.п.), Аура Генератора помех.
//   - Возвращает { ok, reason? }.
//
// Используется:
//   - Фиксер (Синтетикс) — Приказ 2-й линии. Будет рефакторнут на этот хелпер
//     отдельным шагом, чтобы не плодить регрессии.
//   - Перегруппировка (Глобал, В.1.f-1) — переместить союзника на свободный слот.

// C.1: Цепь командования удалена. Подкрепление — новая фракционная аура Глобала.
import { recomputeLineTriggers } from './keywords/line-triggers.js';
import { recomputeReinforcement } from './keywords/reinforcement.js';

export function moveUnit(state, unit, destLine, destSlot) {
  if (!unit) return { ok: false, reason: 'no_unit' };
  if (unit.line === null || unit.slot === null) return { ok: false, reason: 'unit_off_field' };
  if (destLine < 0 || destLine > 1 || destSlot < 0 || destSlot > 3) {
    return { ok: false, reason: 'bad_destination' };
  }
  if (unit.line === destLine && unit.slot === destSlot) {
    return { ok: false, reason: 'same_slot' };
  }
  const owner = state.players[unit.ownerId];
  if (owner.field[destLine][destSlot] !== null) {
    return { ok: false, reason: 'destination_occupied' };
  }
  const fromLine = unit.line, fromSlot = unit.slot;
  // Снять с прежней ячейки.
  owner.field[unit.line][unit.slot] = null;
  // Поставить на новую.
  owner.field[destLine][destSlot] = unit;
  unit.line = destLine;
  unit.slot = destSlot;
  // C.1: пересчёт Подкрепления + line-триггеров после перемещения.
  recomputeReinforcement(state);
  recomputeLineTriggers(state);
  // Этап 23: полноценное событие onUnitMoved (Сдвиг, Ёж, Резонанс/Подавление).
  notifyMoveListeners(state, { unit, fromLine, fromSlot, toLine: destLine, toSlot: destSlot });
  return { ok: true };
}

// В.1.f-1: late-binding для подписчиков движения (Аура Генератора помех).
// Тот же паттерн, что у silenceChange: var-hoisted массив без TDZ.
// eslint-disable-next-line no-var
var _moveListeners;
export function registerMoveListener(fn) {
  if (!_moveListeners) _moveListeners = [];
  if (typeof fn === 'function') _moveListeners.push(fn);
}
function notifyMoveListeners(state, event = null) {
  if (!_moveListeners) return;
  for (const fn of _moveListeners) {
    try { fn(state, event); } catch { /* defensive */ }
  }
}
